<template>
	<div class="casediv">
		<el-row :gutter="0" type="flex" class="row-bg" justify="center">
			<el-col :xs="15" :sm="5" :md="5" :lg="5" :xl="6">
				<div class="divcenter-f">{{ this.user.typeName }}</div>
			</el-col>
			<el-col :xs="6" :sm="2" :md="2" :lg="2" :xl="3">
				<div class="divcenter-f">{{ this.user.name }}</div>
			</el-col>
			<el-col :xs="15" :sm="5" :md="5" :lg="5" :xl="6">
				<div class="divcenter-f">{{ now }}</div>
			</el-col>
		</el-row>
		<div class="myCase" :class="{divBack:tabelmsg.indexOf('我的案件') != -1}">
			<el-row type="flex" class="row-bg" justify="center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="bg-purple-new">
						<router-link to="../qualityUploadData/0">
							<div class="grid-content bg-purple divleft addCase">
								上传图片视频
							</div>
						</router-link>
            <!-- <router-link to="../dataList/0"  v-if="userInfo.dlrAdvanceUser">
            	<div class="grid-content bg-purple divleft addCase">
            		上传图片视频
            	</div>
            </router-link> -->
					</div>
				</el-col>
			</el-row>
			<el-row type="flex" class="row-bg" justify="center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="bg-purple-new">
						<router-link to="dataList/1">
							<div class="bg-purple-new divleft">
								草稿
								<span>{{ countData['草稿'] }}</span>
							</div>
						</router-link>
					</div>
				</el-col>
			</el-row>
			<el-row type="flex" class="row-bg" justify="center" v-if="!userInfo.dlrAdvanceUser">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="bg-purple-new">
						<router-link to="dataList/2">
							<div class="bg-purple-new divleft">
								退回
								<span>{{ countData['退回'] }}</span>
							</div>
						</router-link>
					</div>
				</el-col>
			</el-row>
			<el-row type="flex" class="row-bg" justify="center" v-if="userInfo.dlrAdvanceUser">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="bg-purple-new">
						<router-link to="dataList/4">
							<div class="bg-purple-new divleft">
								待审批数据
								<span>{{ countData['待审批'] }}</span>
							</div>
						</router-link>
					</div>
				</el-col>
			</el-row>
			<el-row type="flex" class="row-bg" justify="center">
				<el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<div class="bg-purple-new">
						<router-link to="dataList/3">
							<div class="bg-purple-new divleft">
								我的数据
								<span>{{ countData['我的数据'] }}</span>
							</div>
						</router-link>
					</div>
				</el-col>
			</el-row>
			<el-row type="flex" class="row-bg" justify="center">
				<el-col style="text-align:center" :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
					<router-link to="indexMenu">
						<el-button type="primary">返回</el-button>
					</router-link>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
import {
  mapState
} from 'vuex'

import {
  getCount
} from '@/api/quality'

import {
  Toast
} from 'mint-ui'

const getHandledValue = num => {
  return num < 10 ? '0' + num : num
}

export default {
  created () {
    this.$emit('refr', 'aaa')
    // localStorage.setItem("store",JSON.stringify(this.$store.state))
    if (localStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem('store'))))
    }
    // 在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('store', JSON.stringify(this.$store.state))
    })

    this.userInfo = JSON.parse(localStorage.getItem('user'))

    getCount().then(res => {
      this.countData = res.data
    })
  },
  data () {
    return {
      tabelmsg: '我的案件',
      Type: this.$route.params.Type,
      now: this.getNow(),
      user: '',
      userInfo: {},
      tab: '',
      areaList: [],
      countData: {},
      showbtn: false,
      draft: 0, // 草稿
      untreated: 0, // 未处理
      treating: 0, // 处理中
      closing: 0, // 结案
      headerShowFlg: true,
      tmciShowFlg: '',
      active: false,
      parttimeFlg: false
    }
  },
  methods: {
    changeField () {
      console.log(this.user)
      this.active = true
      switchLevels1('SECTION', this.tab).then(res => {
        this.getCountList()
      })
    },
    changeField1 () {
      this.active = false
      this.tab = ''
      switchLevels('ALL').then(res => {
        this.getCountList()
      })
    },
    getNow () {
      const d = new Date()
      const year = d.getFullYear()
      const month = getHandledValue(d.getMonth() + 1)
      const date = getHandledValue(d.getDate())
      const hours = getHandledValue(d.getHours())
      const minutes = getHandledValue(d.getMinutes())
      const second = getHandledValue(d.getSeconds())
      let resStr = year + '-' + month + '-' + date
      this.now = resStr
      this.user = JSON.parse(localStorage.getItem('user'))
      this.showbtn = this.user.admin
      if (this.user.type != 2) {
        this.headerShowFlg = true
      } else {
        this.headerShowFlg = false
      }
      // tmci 分室长 是否有兼职
      if (this.user.type == 1) {
        if (this.user.levels.length > 1) {
          this.parttimeFlg = true
        } else {
          this.parttimeFlg = false
        }
      }

      this.tmciShowFlg = this.user.level
      // todo
      // this.tmciShowFlg = 'SECTION'

      console.info(this.user)
    },
    caseTabelClick (level) {
      // 案件导航tabel切换用户级别
      if (this.tmciShowFlg === level) {
        return
      }
      switchLevel(level).then((res) => {
        if (res.data.success) {
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-check'
          })
          this.getCountList()
        } else {
          Toast({
            message: res.data.msg,
            iconClass: 'icon el-icon-close'
          })
        }
      })
    },
    getCountList () {
      // 初始化案件数量
      getCountList().then((res) => {
        this.draft = res.data[0]
        this.untreated = res.data[1]
        this.treating = res.data[2]
        this.closing = res.data[3]
      })
    }
  },
  mounted () {
    this.getNow()
  },
  computed: {
    ...mapState({
      userName: state => state.user.userName,
      type: state => state.user.type,
      typeName: state => state.user.typeName
    })
  }
}
</script>
<style>
	.header {
		padding-bottom: 0.15rem;
		border-bottom: 1px solid blue;
	}

	.divBack {
		display: block !IMPORTANT;
	}

	.compartmentCase,
	.myCase,
	.allCase {
		display: none;
	}

	.casediv {
		overflow-x: hidden;
		margin-left: 10px;
		margin-right: 10px;
	}

	.el-row {
		margin-bottom: 20px;

	}

	.el-header,
	.el-footer {
		font-family: "Avenir", Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.el-col {
		border-radius: 4px;
	}

	.bg-purple-dark {
		background: #67c23a;
	}

	.bg-purple {
		background: #409eff;
	}

	.bg-purple-light {
		background: #e6a23c;
	}

	.grid-content {
		border-radius: 4px;
		min-height: 36px;
	}

	.divcenter {
		text-align: center;
		line-height: 44px;
		color: #fff;
		font-size: 14px;
	}

	.divcenter-f {
		text-align: center;
		line-height: 44px;
		color: #000;
		font-size: 14px;
	}

	.divleft {
		text-align: left;
		line-height: 44px;
		color: #333;
		font-size: 14px;
		padding-left: 10px;
	}

	.frontleft {
		float: left;
		width: 40%;
	}

	.divright {
		text-align: left;
		line-height: 44px;
		color: #333;
		font-size: 14px;
		padding-right: 10px;
	}

	.frontright {
		float: right;
		width: 5%;
	}

	.bg-purple-new {
		background: #fff;
	}

	.bg-purple-new span {
		float: right;
		border-radius: 20px;
		background: #e63c3c;
		font-size: 12px;
		display: block;
		height: 20px;
		position: relative;
		top: 11px;
		right: 15px;
		line-height: 23px !IMPORTANT;
		color: #fff;
		text-align: center;
		padding: 0 8px;
	}

	.addCase {
		color: #fff;
		background-color: #00ae66;
	}

	.addCase a {
		color: #fff;
	}
	.active {
		background: #fff;
		color: #333;
	}

	/* .container{width: 100%;} */
</style>
